const EVENT_PREFIX = "HCF Admin Web App (V2):";

export const IMPERSONATION_USER_EVENTS = {
  SESSION_STARTED: `${EVENT_PREFIX} Impersonation session started`,
  SESSION_OPENED: `${EVENT_PREFIX} Impersonation session opened`,
  SESSION_RESTORED: `${EVENT_PREFIX} Impersonation session restored`,
  SESSION_CLOSED: `${EVENT_PREFIX} Impersonation session closed`,
  SESSION_MINIMIZED: `${EVENT_PREFIX} Impersonation session minimized`,
  SESSION_EXPIRED: `${EVENT_PREFIX} Impersonation session expired`,
  SESSION_REFRESHED: `${EVENT_PREFIX} Impersonation session refreshed`,
} as const;

export const IMPERSONATION_APP_EVENTS = {
  SESSION_LIMIT_REACHED: `${EVENT_PREFIX} Impersonation session limit reached`,
  TOKEN_SEND_FAILURE: `${EVENT_PREFIX} Impersonation token send failure`,
  AUTH_FAILURE: `${EVENT_PREFIX} Impersonation auth failure`,
  MISSING_COGNITO_GROUP: `${EVENT_PREFIX} Impersonation missing Cognito group`,
} as const;

export const COGNITO_IMPERSONATION_GROUP = "impersonation";

export const MAX_SESSIONS = 4;
export const MAX_WORKPLACE_SESSIONS = 2;
export const MAX_WORKER_SESSIONS = 3;
export const WARNING_THRESHOLD_MS = 3 * 60 * 1000;
export const EXPIRY_MS = 15 * 60 * 1000;
export const EXPIRY_CHECK_INTERVAL_MS = 10_000;
export const DEFAULT_WORKER_WINDOW_SIZE = { width: 375, height: 667 };
export const WORKPLACE_WINDOW_WIDTH_RATIO = 0.55;
export const WORKPLACE_WINDOW_HEIGHT_RATIO = 0.6;
export const MIN_WINDOW_SIZE = { width: 300, height: 500 };
export const STALE_CLEANUP_MS = 24 * 60 * 60 * 1000;
export const PHONE_BEZEL_WIDTH = 3;
export const PHONE_BEZEL_RADIUS = 40;
export const HEADER_HEIGHT = 36;

const RESIZE_HANDLE_SIZE = 16;
export const RESIZE_HANDLE_SX = {
  position: "absolute",
  right: 0,
  bottom: 0,
  width: RESIZE_HANDLE_SIZE,
  height: RESIZE_HANDLE_SIZE,
  cursor: "nwse-resize",
  "&::after": {
    content: '""',
    position: "absolute",
    right: 3,
    bottom: 3,
    width: 8,
    height: 8,
    borderRight: "2px solid",
    borderBottom: "2px solid",
    borderColor: "grey.400",
  },
} as const;

export function getHeaderBackgroundColor(
  isClosing: boolean,
  error: string | undefined,
  isWarning: boolean
): string {
  if (isClosing) {
    return "grey.600";
  }

  if (error) {
    return "error.main";
  }

  if (isWarning) {
    return "warning.main";
  }

  return "primary.main";
}
